/**
 * TanStack Query hooks for `cpa-safeguard-attribution-fraud-protection`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createRule,
	deleteRule,
	listRules,
	listVerdicts,
	cpaSafeguardAttributionFraudProtectionQueryKeys,
	type CreateRuleBody,
	type ListRulesResponse,
	type ListVerdictsResponse,
	type Rule,
} from "./api";

export function useCpaSafeguardAttributionFraudProtectionRulesList(): UseQueryResult<
	ListRulesResponse,
	Error
> {
	return useQuery({
		queryKey: cpaSafeguardAttributionFraudProtectionQueryKeys.rules(),
		queryFn: listRules,
	});
}

export function useCpaSafeguardAttributionFraudProtectionVerdictsList(): UseQueryResult<
	ListVerdictsResponse,
	Error
> {
	return useQuery({
		queryKey: cpaSafeguardAttributionFraudProtectionQueryKeys.verdicts(),
		queryFn: listVerdicts,
	});
}

export function useCpaSafeguardAttributionFraudProtectionCreateRule(): UseMutationResult<
	{ rule: Rule },
	Error,
	CreateRuleBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createRule,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: cpaSafeguardAttributionFraudProtectionQueryKeys.all,
			});
		},
	});
}

export function useCpaSafeguardAttributionFraudProtectionDeleteRule(): UseMutationResult<
	{ ok: boolean; id: number },
	Error,
	number
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: deleteRule,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: cpaSafeguardAttributionFraudProtectionQueryKeys.all,
			});
		},
	});
}
